export default "__VITE_ASSET__CnUULkTV__"